import { Component, EventEmitter, OnInit, Output, Inject, PLATFORM_ID } from '@angular/core';
import { AuthService, ConstantService, HelperService, ApiService, PaginationService } from '../../core/services';
import { ActivatedRoute, NavigationEnd, NavigationStart, Params, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NgxSpinnerService } from "ngx-spinner";
import { isPlatformBrowser, isPlatformServer } from
  '@angular/common';

@Component({
  selector: 'app-podcast-news',
  templateUrl: './podcast-news.component.html',
  styleUrls: ['./podcast-news.component.css']
})
export class PodcastNewsComponent implements OnInit {

  podcastId: any;
  userSubscription: Subscription;
  podcastNewsList: any = [];
  @Output() onAudioPlay = new EventEmitter<any>();
  episodeArray: any = [];
  pager: any = {};

  // paged items
  pagedItems: any[];
  //---------------------
  total_record: number = 0;
  userRole: any;
  nextPage: any;
  prevPage: any;
  page: any = 1;
  alias: any = '';
  total: any = 0;
  totalPages: any = 0;
  objectKeys = Object.keys;

  constructor(private authSvc: AuthService,
    private constantSvc: ConstantService,
    private apiSvc: ApiService,
    private helperSvc: HelperService,
    private pagerService: PaginationService,
    private router: Router, private spinner: NgxSpinnerService,
    private _route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platform: Object) { }

  ngOnInit(): void {
    this.getAllPodcastNews();
  }

  getAllPodcastNews() {
    this.spinner.show();
    this.apiSvc.getService(this.constantSvc.APIConfig.GETALLPODCASTARTICLENEWS, '?page=1' + '&cat_id=20').subscribe(
      res => {
        if (res) {
          let data = res;
          this.podcastNewsList = data.allarticlesLists;
          this.totalPages = data.total_no_of_page;
          this.total = 15 * (this.totalPages);

          // this.pager = this.pagerService.getPager(this.total, 1, 15);
          // console.log("this.pager", this.pager);
          this.spinner.hide();
        }
      }, err => {
        this.spinner.hide();
      }
    );
  }

  // viewMore(page: number) {
  viewMore() {
    let page = this.page + 1;
    this.page = page;
    if(this.totalPages >= page){
      this.handlePageChange(page);
    }
  }

  handlePageChange(event: any) {
    this.page = event;
    this.apiSvc.getService(this.constantSvc.APIConfig.GETALLPODCASTARTICLENEWS, '?cat_id=20' + '&page=' + this.page).subscribe(
      res => {
        if (res) {
          let data = res;
          let podcastNewsList = data.allarticlesLists;
          this.podcastNewsList = this.podcastNewsList.concat(podcastNewsList);
          this.totalPages = data.total_no_of_page;
          this.total = 15 * (this.totalPages);
          // this.pager = this.pagerService.getPager(this.total, this.page, 15);
          // console.log("this.pager", this.pager);
        }
      }, err => {
      }
    );
    // if (isPlatformBrowser(this.platform)) {
    //   window.scrollTo(0, 0);
    // }
  }
}
